import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import React from "react";

import { card } from "../../card.style";

export type CardFooterComponentProps = {};

export type CardFooterProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, CardFooterComponentProps, "div">;

const CardFooter = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: CardFooterProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const { footer } = card({});

    return (
        <Tag
            {...attributes}
            className={footer({ className })}
        />
    );
};

export { CardFooter };
